import _ from "lodash";
import { Text, Title, Divider, Group, ThemeIcon, Badge } from "@mantine/core";
import React from "react";
import moment from "moment";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";

import { IconClick, IconCash, IconHeart } from "@tabler/icons-react";

export default function ClientBasicInfo({ form }) {
  const [cellRender] = useCellRender();
  const client = form.values;
  const dataFontWeight = 600;

  const emptyStr = "-";

  const fields = [
    { title: "Name", value: client.name ?? emptyStr },
    { title: "Chinese Name", value: client.cname ?? emptyStr },
    { title: "Client Type", value: client.type ?? emptyStr },

    { title: "Phone Number", value: client.phoneNumber ?? emptyStr },
    { title: "Industry", value: client.industry ?? emptyStr },

    { title: "Email", value: client.email ?? emptyStr },

    { title: "Status", value: client.status ?? emptyStr },
    { title: "Code", value: client.code ?? emptyStr },

    {
      title: "Created At",
      value: cellRender.Date(client.createdAt, "LL", dataFontWeight),
    },
  ];
  return <InfoGridList fields={fields} values={client} />;
}
